import { Observable } from 'rxjs/Observable';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { SelectItem } from 'primeng/primeng';

import { Risk } from 'app/entities/transaction-profile/risk.model';
import { EntityTransactionProfileService } from 'app/entities/transaction-profile/entity-transaction-profile.service';
import { WarmUpService, ApplicationTypeConstants } from 'app/services/warmup/warmup.service';

@Component({
    selector: 'add-risk',
    templateUrl: './add-risk.component.html',
    styleUrls: ['./add-risk.component.css']
})
/**
 * Component to add a new right.
 */
export class AddRiskComponent implements OnInit {
    selectedRisk: Risk;
    agreementId: number;
    addRiskForm: FormGroup;
    loading = false;
    riskId: string;
    actionType: string;
    controlRiskType = 'riskType';

    formErrors = {
        'name': '',
        'riskType': '',
    };

    validationMessages = {
        'name': {
            'required': 'Required field value.',
        },
        'riskType': {
            'required': 'Required field value.',
        }
    };

    constructor(
        public dialogRef: MdDialogRef<any>,
        private fb: FormBuilder,
        private entityTransactionProfileService: EntityTransactionProfileService,
        private snackBarService: SnackBarService,
        private warmUpService: WarmUpService,
        private cdr: ChangeDetectorRef
    ) { }

    ngOnInit() {
        this.buildForm();
        // Risk Types from application values.
        this.setupControlValues(this.controlRiskType, (this.warmUpService.getApplicationValue(ApplicationTypeConstants.ENTITY_RISK_TYPE)));
    }

    setupControlValues(control, dropDownValues: any) {
        if (dropDownValues instanceof Observable) {
            dropDownValues.subscribe(
                response => {
                    this.warmUpService.setApplicationTypeInLS(response);
                    this[control] = response.values;
                    this.cdr.detectChanges();
                }
            );
        } else {
            this[control] = dropDownValues;
        }
    }

    getControlValues(controlName) {
        return this[controlName];
    }

    buildForm() {
        this.addRiskForm = this.fb.group({
            name: ['', Validators.required],
            riskType: ['', Validators.required],
        });
        this.addRiskForm.valueChanges.subscribe(data => this.onValueChanged(data));
        this.onValueChanged();
    }

    onValueChanged(data?: any) {
        if (!this.addRiskForm) {
            return;
        }
        const form = this.addRiskForm;
        for (const field in this.formErrors) {
            // clear previous error message (if any)
            this.formErrors[field] = '';
            const control = form.get(field);
            if (control && control.touched && !control.valid) {
                const messages = this.validationMessages[field];
                for (const key in control.errors) {
                    this.formErrors[field] += messages[key] + ' ';
                }
            }
        }
    }

    onSubmit({ value, valid }) {
        this.loading = true;
        const risk = new Risk();
        risk.title = value.name;
        risk.type = value.riskType;
        risk.agreementId = this.agreementId;
        this.entityTransactionProfileService.addRisk(risk)
            .subscribe(response => {
                if (response.flagResult) {
                    this.dialogRef.close(response);
                }
                this.callSnackBarService(response);
            }, err => {
                this.callSnackBarService(err);
            });
    }

    callSnackBarService(response: any) {
        this.snackBarService
            .showStatus(response,
            MessageService.RISK_SUCCESS_TEMPLATE.replace('%s', 'added'),
            MessageService.RISK_FAILURE_TEMPLATE.replace('%s', 'add'));
    }

    closeDialog(): void {
        this.addRiskForm.reset();
        this.dialogRef.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/entities/transaction-profile/risks/addrisk/add-risk.component.ts